import React, { ReactNode } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useRenderOn } from "src/hooks";
import styled from "styled-components";

import { Hyperlink } from "..";
import i18n from "../../i18n";
import client from "../../lib/graphql";
import { translate } from "../../services/translation.service";
import theme, { media } from "../../theme";
import { Mapping } from "../../types/primitives";

import { ILanguageFooterItemType } from "./LangageItem.constants";

const LanguageItemImage = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 5px;
`;

const LanguageItemLabel = styled.div`
  color: white;
  margin-right: 10px;
  font-family: ${theme.fonts.regular};
  font-size: 13px;

  ${media.laptop} {
    font-size: ${theme.fontSizes.tiny};
    text-transform: uppercase;
  }
`;

interface ILanguageItem {
  children: string | ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  to?: string;
  background?: string;
}

const LanguageItemWrapper = styled((props: ILanguageItem) => (
  <Hyperlink {...props} />
))`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding: 1px 7px 2px;
`;

const getTarget = ({
  pathname,
  alts,
  languageItem,
}: {
  pathname: string;
  alts?: Mapping;
  languageItem: ILanguageFooterItemType;
}): string => {
  if (alts && pathname === alts[i18n.language]) {
    return alts[languageItem.value];
  } else if (languageItem.value === "en") {
    return "/en" + pathname;
  } else {
    return pathname.replace(/^\/en/, "") || "/";
  }
};

interface IProps extends RouteComponentProps {
  alts?: Mapping;
  languageItem: ILanguageFooterItemType;
}

const LanguageItem = ({
  languageItem,
  alts,
  location,
}: IProps): JSX.Element => {
  const { mdOrDown, lgOrUp } = useRenderOn();

  const onClick = (): void => {
    i18n.changeLanguage(languageItem.value);
    client.resetStore();
  };

  const target = getTarget({
    alts,
    languageItem,
    pathname: location.pathname,
  });

  return (
    <LanguageItemWrapper
      key={languageItem.value}
      onClick={onClick}
      to={target}
      className="langPicker"
    >
      {mdOrDown && (
        <LanguageItemLabel>{translate(languageItem.label)}</LanguageItemLabel>
      )}
      <LanguageItemImage
        src={languageItem.imgSrc}
        alt={
          languageItem.value === "en"
            ? translate("global.language.englishFlag")
            : translate("global.language.frenchFlag")
        }
      />

      {lgOrUp && (
        <LanguageItemLabel>
          {translate(languageItem.desktopLabel)}
        </LanguageItemLabel>
      )}
    </LanguageItemWrapper>
  );
};

export default withRouter(LanguageItem);
